import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import {
  AboutusContainer,
  Superpowercontent,
  Superpowerimg,
  Superpowersection,
  Title,
} from '../Aboutmylo/styled';

export default function index() {
  return (
    <>
      <Superpowersection>
        <Title>SUPER POWERS of MYLO :</Title>
        <p>
          Choose from over 500+ topics ranging from baby care and pregnancy, to
          parenting, postpartum tips, health and recipes. Track your baby&apos;s
          development week by week, get pregnancy fitness tips, guides on
          pregnancy scans &amp; tests, pregnancy and newborn baby tools,
          utilities, guides, new mom checklist and diet charts for you and your
          baby&apos;s growth.
        </p>
      </Superpowersection>
      <AboutusContainer>
        <div className="section">
          <Superpowerimg src={images.dailytip} alt="" />
          <Title>Daily Latest Tips, Articles and Videos for you</Title>
          <Superpowercontent>
            Our daily digest will provide you the best information personalized
            to your stage, verified by experts. The content is refreshed daily
            to keep you up to date on information essential for your baby’s
            growth and your body’s health
          </Superpowercontent>
        </div>
        <div>
          <Superpowerimg src={images.qnaimg} alt="" />
          <Title>Questions and Answers</Title>
          <Superpowercontent>
            Have a lot of questions? Mylo helps you get all of those answered –
            either by fellow Indian pregnant women or by health experts. You may
            have medical questions or need support to handle pregnancy emotions,
            or you may even just feel like sharing your experiences. Women in
            the Mylo community who have been through the same are always looking
            out for you.
          </Superpowercontent>
        </div>
      </AboutusContainer>
      <AboutusContainer>
        <div className="section">
          <Superpowerimg src={images.toolguides} alt="" />
          <Title>Tools, Guides and Utilities</Title>
          <Superpowercontent>
            Get the best tools and utilities to help you during conception,
            pregnancy and after delivery. Find tools like Ovulation calculator,
            Chinese gender predictor, Due date calculator, Baby names finder,
            Pregnancy and Baby sleep music, horoscope and much more…
          </Superpowercontent>
        </div>
        <div>
          <Superpowerimg src={images.community} alt="" />
          <Title>Share stories &amp; Create polls in community</Title>
          <Superpowercontent>
            You may face situations in life and need support, or you may even
            just feel like sharing your experiences – experienced moms at Mylo
            will help you with all. Share stories and get opinions in polls from
            the women in the Mylo community who are eager to help everyone.
          </Superpowercontent>
        </div>
      </AboutusContainer>
    </>
  );
}
